import { Button, DesktopModal, Loading, TextArea } from '@byecode/ui'
import Editor from '@monaco-editor/react'
import React, { useEffect, useMemo, useState } from 'react'

import SelectMOdel from '../../LLMActionConfigure/SelectModel'
import * as SC from './styles'

type CodeModalProps = {
    isOpen: boolean
    onClose: () => void
    getCode: (code: string) => void
}

const DefaultText = () => {
    return (
        <SC.DefaultText>
            <SC.Icon type="AIStar" size={68} color="var(--color-gray-300)" />
            <SC.DefaultTextTitle>在左侧描述您的用例，代码预览将在此处显示。</SC.DefaultTextTitle>
        </SC.DefaultText>
    )
}

const Coding = () => {
    return (
        <SC.DefaultText>
            <Loading shape="indicator" description="代码生成中" showProgress={false} />
        </SC.DefaultText>
    )
}

const EditorArea = ({ code }: { code: string }) => {
    // const [code, setCode] = useState<string>('');

    const handleCodeChange = () => {
        //
    }

    return (
        <SC.DefaultText>
            <SC.EditorContainer>
                <Editor
                    height="100%"
                    language="python"
                    value={code}
                    onChange={handleCodeChange}
                    options={{
                        readOnly: true,
                        fontSize: 14,
                        minimap: { enabled: false },
                        lineNumbers: 'on',
                        folding: true,
                        automaticLayout: true,
                        scrollBeyondLastLine: false,
                        tabSize: 2,
                        lineNumbersMinChars: 2 // 设置最小宽度（字符宽度）
                    }}
                />
            </SC.EditorContainer>
        </SC.DefaultText>
    )
}

const UpperLimitModal = ({ onClose }: { onClose: () => void }) => {
    return (
        <SC.UpperLimitModal>
            <SC.UpperInner>
                <SC.Close onClick={onClose}>
                    <SC.Icon type="Close" size={16} />
                </SC.Close>
                <SC.UpperHeader>
                    <SC.IconOuter>
                        <SC.Icon type="TongYi" size={24} />
                    </SC.IconOuter>
                    <SC.UpperHeaderContent>
                        <SC.UpperTitle>LLM Token达到上限</SC.UpperTitle>
                        <SC.UpperDesc>
                            <SC.UpperDescLeft>相关功能无法使用，请升级版本</SC.UpperDescLeft>
                            <SC.UpperDescRight>1/1</SC.UpperDescRight>
                        </SC.UpperDesc>
                        <SC.UpperProgress />
                    </SC.UpperHeaderContent>
                </SC.UpperHeader>
                <SC.UpperFooter>
                    <SC.Look>查看配额</SC.Look>
                    <SC.Upgrade>升级版本</SC.Upgrade>
                </SC.UpperFooter>
            </SC.UpperInner>
        </SC.UpperLimitModal>
    )
}

const CodeModal: React.FC<CodeModalProps> = ({ isOpen, onClose, getCode }) => {
    const [loading, setLoading] = useState(false)

    const [limitOpen, setLimitOpen] = useState(false)

    const [desc, setDesc] = useState('')

    const [code, setCode] = useState('')

    const [status, setStatus] = useState<'start' | 'loading' | 'success'>('start')

    const handleGetCode = (code: string) => {
        getCode(code)
    }

    const statusComponent = useMemo(() => {
        switch (status) {
            case 'start': {
                return <DefaultText />
            }
            case 'loading': {
                return <Coding />
            }
            case 'success': {
                return <EditorArea code={code} />
            }
            // No default
        }
    }, [status, code])

    const handleSubmit = () => {
        // setLoading(true)
        setStatus('loading')
        setTimeout(() => {
            const val = 'print("Hello, World!")'
            setCode(val)
            setStatus('success')
        }, 1000)
    }

    const handleApply = () => {
        getCode(code)
        onClose()
    }

    useEffect(() => {
        if (!isOpen) {
            setLoading(false)
            setStatus('start')
        }
    }, [isOpen])

    return (
        <SC.Layout>
            <DesktopModal
                open={isOpen}
                onClose={onClose}
                width={982}
                styles={{
                    body: {
                        padding: '0!important',
                        paddingBottom: '20px !important'
                    },
                    header: {
                        borderStyle: 'none',
                        height: '48px'
                    }
                }}
            >
                <SC.Container>
                    {limitOpen && <UpperLimitModal onClose={() => setLimitOpen(false)} />}
                    <SC.Left>
                        <SC.Title>代码生成器</SC.Title>
                        <SC.Desc>代码生成器使用配置的模型根据您的指令生成高质量的代码。请提供清晰详细的说明。</SC.Desc>

                        <SC.Item>
                            <SC.ItemTitle>模型</SC.ItemTitle>
                            <SelectMOdel
                                value="1-1"
                                onChange={() => {
                                    //
                                }}
                            />
                        </SC.Item>

                        <SC.Item>
                            <SC.ItemTitle>指令</SC.ItemTitle>
                            <TextArea
                                style={{
                                    width: '100%',
                                    height: '155px'
                                }}
                                placeholder="请输入您想要生成的代码的详细描述。"
                                onChange={e => {
                                    setDesc(e.target.value)
                                }}
                            />
                        </SC.Item>
                        <SC.Footer opacity={1}>
                            <Button size="lg" style={{ width: 104 }} onClick={onClose}>
                                取消
                            </Button>
                            <Button
                                size="lg"
                                disabled={!desc}
                                style={{ width: 104 }}
                                loading={loading}
                                type="primary"
                                onClick={handleSubmit}
                            >
                                生成
                            </Button>
                        </SC.Footer>
                    </SC.Left>
                    <SC.CenterBorder height={status === 'success' ? 562 : 508} />
                    <SC.Right>{statusComponent}</SC.Right>
                </SC.Container>

                <SC.RightFooter display={status === 'success' ? 'flex' : 'none'}>
                    <Button size="lg" style={{ width: 104 }} onClick={onClose}>
                        取消
                    </Button>
                    <Button onClick={handleApply} size="lg" style={{ width: 104 }} type="primary">
                        应用
                    </Button>
                </SC.RightFooter>
            </DesktopModal>
        </SC.Layout>
    )
}

export default CodeModal
